import React, { useRef, useEffect } from 'react'
import { Modal } from 'antd'
import { useHistory } from 'react-router'

interface Props {
  loginCardVisible: boolean
  url: string
  setVisible: (visible: boolean) => void
}
const RedirectCardCom: React.FC<Props> = ({ loginCardVisible, url, setVisible }) => {
  const imageRef = useRef<HTMLImageElement | null>(null)
  setTimeout(() => {
    if (loginCardVisible === true) {
      setVisible(false)
      loginCardVisible = false
      window.open(url, '_blank')
    }
  }, 2000)



  const navigateToLogin = () => {
    window.open(url, '_blank')
    setVisible(false)
    loginCardVisible = false
  }

  const cancelToLogin = () => {
    setVisible(false)
    loginCardVisible = false
  }
  return (
    <>
      <Modal
        width={1200}
        closable={false}
        centered={true}
        visible={loginCardVisible}
        okText="继续"
        cancelText="取消"
        maskClosable={false}
        onCancel={cancelToLogin}
        onOk={navigateToLogin}
      >
        <div style={{ backgroundColor: '#FFE4D9', color: '#ED3811', borderRadius: 5, marginBottom: 24, alignItems: 'center', display: 'flex', padding: 10 }}>
          <img src={'/images/warn.svg'} width={36} height={32}></img>
          <span style={{ fontSize: 24, marginLeft: 20 }}>请注意您的账号和财产安全</span>
        </div>
        <div style={{ fontSize: 18 }}>您即将离开AI教育资源云平台，去往：<span style={{ color: 'red' }}>{url}</span>，本平台对外部系统的内容和安全性不承担任何责任。</div>
      </Modal>
    </>
  )
}

export default RedirectCardCom
